/**
 * 电子杂志相关接口（PC 端 + 移动端）
 */
import request from './request'
import { API_BASE_URL } from '../config'

/**
 * 获取杂志列表（PC 端）
 * @param {object} params - { year, pageNum, pageSize }
 */
export function getMagazineList(params) {
  return request.post('/api/emagazine/list', params)
}

/**
 * 获取杂志阅读信息（PC 端）
 * @param {object} params - { emagazineCode }
 * @returns {Promise<object>} 返回 data 中 pdfPath 已补全为完整 URL
 */
export async function getMagazineView(params) {
  const res = await request.post('/api/emagazine/view', params)
  const data = res.data || {}
  if (data.pdfPath && !data.pdfPath.startsWith('http')) {
    data.pdfPath = `${API_BASE_URL}${data.pdfPath}`
  }
  return res
}

/**
 * 获取杂志年份列表（PC 端）
 * @returns {Promise<object>}
 */
export function getMagazineYearList() {
  return request.post('/api/emagazine/yearList')
}

/**
 * 获取我的电子杂志列表（移动端）
 * @param {object} params - { pageNum, pageSize }
 */
export function getMyMagazineList(params) {
  return request.post('/api/emagazine/myList', params)
}
